export default "__VITE_ASSET__9428581b__"